<template>
  <div class="column full-height">
    <header
      class="row items-center justify-between q-px-2x-md full-width no-wrap"
      :style="{ height: '76px' }"
    >
      <span
        class="text-lg text-neutral text-weight-medium"
        :style="{ maxWidth: '75%' }"
      >
        Activity Logs
      </span>

      <PBtn color="primary" flat round @click="onClose">
        <CloseIcon class="icon" />
      </PBtn>
    </header>

    <q-separator color="neutral-40" />
    <div class="q-px-2x-md q-py-xl col overflow-auto">
      <PTimeline>
        <div v-if="!combinedTimelines?.length">No activity yet!</div>
        <PTimelineEntry
          v-for="(timeline, index) in combinedTimelines"
          :key="index"
        >
          <div class="text-sm text-neutral">
            {{ timeline?.remarks || "-" }}
          </div>
          <div class="text-xs text-neutral-70">
            {{ formatDate(timeline?.created_date, "DD MMM YYYY, h:mm a") }}
          </div>
        </PTimelineEntry>
      </PTimeline>
    </div>
  </div>
</template>
<script setup>
import CloseIcon from "assets/icons/close.svg";
import { date } from "quasar";

const { formatDate } = date;
const { toggleActivityLogsDrawer } = useRoleManagementStore();
const { roles } = storeToRefs(useRoleManagementStore());

const combinedTimelines = computed(() => {
  const timelines = roles.value.flatMap((role) => role.timelines);

  timelines.sort((a, b) => new Date(b.created_date) - new Date(a.created_date));

  return timelines;
});

const onClose = () => {
  toggleActivityLogsDrawer({
    open: false,
  });
};
</script>
